import {useState, useEffect} from 'react';
import {PieChart} from '@mui/x-charts/PieChart';
import {getRoute} from '../api/routes';
import api from '../Interceptor';
import {width} from '@mui/system';
import {useMediaQuery} from 'react-responsive';

const SuperAdmin_UserStatusGraph = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 640);
  const [isTablet, setIsTablet] = useState(
    window.innerWidth > 640 && window.innerWidth <= 1024
  );
  const [activeUsers, setActiveUsers] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);

  const isSmallScreen = useMediaQuery({maxWidth: 640}); // Mobile
  const isMediumScreen = useMediaQuery({maxWidth: 1024}); // Tablet

  const chartSize = isSmallScreen ? 250 : isMediumScreen ? 320 : 400;
  const innerRadius = chartSize * 0.3;
  const outerRadius = chartSize * 0.36; // Slightly larger for better visibility
  const cx = chartSize / 2;
  const cy = chartSize / 2;


  const fetchUsers = async () => {
    try {
      const response = await api.get(
        getRoute('users', 'superadmin', 'admin', false, true, 'list')
      );

      if (response?.data) {
        const users = response.data;
        const activeStatusId = process.env.REACT_APP_STATUS_ACTIVE;
        const active = users.filter(
          (user) => user.status === activeStatusId
        ).length;
        const total = users.length;

        setActiveUsers(active);
        setTotalUsers(total);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchUsers();

   
  }, []);

  return (
    <div className="bg-white text-center relative  rounded-lg w-full max-w-md mx-auto">
      <div className="text-sm font-bold text-left">Users</div>
      <div className="flex justify-center items-center relative">
        <PieChart
          series={[
            {
              data: [
                {id: 0, value: totalUsers, label: 'Total', color: '#E0E0E0'},
              ],
              innerRadius,
              outerRadius,
              startAngle: 0,
              endAngle: 360,
              cx,
              cy,
            },
            {
              data: [
                {id: 1, value: activeUsers, label: 'Active', color: '#002DD1'},
              ],
              innerRadius: innerRadius - 10,
              outerRadius: outerRadius + 10,
              startAngle: 0,
              endAngle: (activeUsers / (totalUsers || 1)) * 360, // Prevent division by zero
              cx,
              cy,
            },
          ]}
          width={chartSize}
          height={chartSize}
          legend={{hidden: true}}
        />

        {/* Centered User Icon */}
        <div
          className="absolute bg-gray-200 rounded-full flex items-center justify-center shadow-md"
          style={{
            width: chartSize * 0.25,
            height: chartSize * 0.25,
            top: '51%',
            left: '51%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <i className="fa-solid fa-user text-[#002DD1] text-3xl"></i>
        </div>
      </div>
      {/* Legend Section */}
      <div className="flex justify-center gap-4 mt-4">
        <div className="flex items-center">
          <i className="fa-solid fa-circle text-sm text-gray-400 mr-1"></i>
          <span className="text-sm text-gray-600">
            Total Users: {totalUsers}
          </span>
        </div>
        <div className="flex items-center">
          <i className="fa-solid fa-circle text-sm text-[#002DD1] mr-1"></i>
          <span className="text-sm text-gray-600">
            Active Users: {activeUsers}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SuperAdmin_UserStatusGraph;
